import TodosLosEstudiantesPage from "./TodosLosEstudiantes";
//import CuentaEfectivo from "../components/resumenes/CuentaEfectivo";
import { useState } from "react";
import TodosLosRecurrentesPage from "./TodosLosRecurrentes";
import TodasLasHabitacionesPage from "./TodasLasHabitaciones";
import TodosLosRecordatoriosPage from "./TodosLosRecordatorios";

function InicioPage(props) {
  const [recargar, setRecargar] = useState(false);

  //console.log("recargar", recargar);
  return (
    <section className="centrarElem">
      {props.casaSel > 0 ? (
        <section className="centrarElem">
          <TodosLosRecordatoriosPage
            casaSel={props.casaSel}
            nivel={props.nivel}
            muestra={"lista"}
            setRecargar={setRecargar}
          />
          <TodasLasHabitacionesPage
            casaSel={props.casaSel}
            nivel={props.nivel}
            muestra={"SinLlave"}
            tipo={"Mini"}
            setRecargar={setRecargar}
          />
          <TodosLosEstudiantesPage
            casaSel={props.casaSel}
            nivel={props.nivel}
            muestra={"Adeudo"}
            setRecargar={setRecargar}
          />
          <section className="centrarElem">
            <TodosLosRecurrentesPage
              casaSel={props.casaSel}
              nivel={props.nivel}
              recargar={recargar}
              muestra="Inicio"
              setRecargar={setRecargar}
            />
          </section>
        </section>
      ) : (
        <section>
          <h1>Primero selecciona la casa</h1>
        </section>
      )}
    </section>
  );
}

export default InicioPage;
